import { useMutation } from '@tanstack/react-query';

import { blockListZeroSubmission } from '../Admin.api';

export default function useBlockListZeroMutation(options?: any) {
  return useMutation(blockListZeroSubmission, options);
}
